import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { debounceTime } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { uniqBy as _uniqBy } from 'lodash';
import { EssDeviceDto } from 'src/app/shared/equipment-search/ess-device.dto';
import { EquipmentSearchService } from 'src/app/shared/equipment-search/equipment-search.service';
import { DomEventService } from 'src/app/core/services/event/dom-event/dom-event.service';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'aldcs-device-autocomplete',
  templateUrl: './device-autocomplete.component.html',
  styleUrls: ['./device-autocomplete.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AutocompleteDeviceSearchComponent implements OnInit {
  @Output() deviceSelectedEvent = new EventEmitter();
  @Output() noDeviceSatisfactoryEvent = new EventEmitter();
  @Input()
  deviceTypes: Array<number | string | undefined | null> = [];

  public errorMessage: string = '';
  public backgroundImageURL: string = '';

  private searchResults: (EssDeviceDto | { Description?: string })[] = [];
  public uniqueSearchResults: (EssDeviceDto | { Description?: string })[] = [];
  public loading: boolean = false;
  public noSearchResultsDisplayMessage: string = "";
  public constructor(
    private equipmentSearchService: EquipmentSearchService,
    private resourceService: ADPResourceService,
    private domEventService: DomEventService,
  ) { }

  searchControl = new FormControl('');

  ngOnInit() {
   this.noSearchResultsDisplayMessage = this.resourceService.getPortalLabel("DeviceSearch_NoResults_Label").Value.replace('<div>','').replace('</div>','');
   this.backgroundImageURL = this.resourceService.getPortalImage("Global_Device_Search").ImageURL;

    this.searchControl.valueChanges
      .pipe(debounceTime(500))
      .subscribe(value => {
        this.search(value);
      });
  }

  displayFn(option: any) {
    return option.Description;
  }

  private search(searchQuery: any) {
    // Only search if the query is a string with at least 2 characters
    if (!searchQuery || searchQuery?.length < 2 || searchQuery?.Description) {
      return;
    }
    this.loading = true;

    this.equipmentSearchService.search(searchQuery).subscribe({
      next: (response) => {
        let filteredList = response.value ?? [];;
        if (this.deviceTypes?.length > 0) {
          filteredList = filteredList.filter(x => this.deviceTypes.includes(x?.Attributes?.DeviceTypeCode));
        }

        this.searchResults = filteredList;

        // Remove duplicate entries.
        this.uniqueSearchResults = _uniqBy(filteredList ?? [], 'Description');

        this.uniqueSearchResults.push({ Description: this.noSearchResultsDisplayMessage });

        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
      },
    });
  }

  public selected(event: MatAutocompleteSelectedEvent) {
    if (event.option.value.Description === this.noSearchResultsDisplayMessage) {
      this.noDeviceSatisfactoryEvent.emit();
      this.searchControl.setValue('');
    } else {
      const essDevice: EssDeviceDto = { ...event.option.value };

      // See if selected device was one that had multiple entries for the same description and remove the ModelIdentifier property if that is the case.
      // There is a business requirement that when there are multiple entries with the same description, then we can't save the ModelIdentifier property into the Device Inventory / Elita
      const itemsWithSameDescription = this.searchResults.filter((x) => x.Description === essDevice.Description);
      if (itemsWithSameDescription.length > 1) {
        delete essDevice.ModelIdentifier;
      }
      this.deviceSelectedEvent.emit(essDevice);
    }
  }

  public addToProducts(){
    this.noDeviceSatisfactoryEvent.emit();
  }
}
